// export const BACKEND_URL = "http://backend:3003";
// export const BACKEND_URL = "http://194.233.80.167:3003";
// export const BACKEND_URL = "https://backend.api.sumairatariq.com";
// export const BACKEND_URL = "http://192.168.1.122:5000"
// export const BACKEND_URL = "https://stbackend.softsyncdev.work";
// export const BACKEND_URL = "http://localhost:5000";
export const BACKEND_URL = "https://backend.sumairatariq.com";
export const POSTEX_URL = "ZDNlYTllYWI5NTA2NGY4NWJhY2RjODkwYjg1N2QxNDM6ZGRlNzI4OGUzOGQzNDM4MmEyY2RkMGJkYmJlY2NhNzI=";
// export const POSTEX_URL = "NzE0OWJjMzUwNWUxNDdhYjhkYTgxMmU0ZjAwNGI2MjM6OTQ3NmQ4MzcxZGYyNGNkYWIwNDgxNWI4ZTJiODhkMWU=";
// export const BACKEND_URL = "http://192.168.1.130:5000";
